module.exports = __webpack_public_path__ + "img/about__loyalty-img.b6e3b659.jpg";